import { useCallback, useMemo, type ReactNode } from "react";

import type { DesignerNode } from "../../types";
import { CssBindingsContext } from "./CssBindingsContext";

type Props = {
  children: ReactNode;
  bindings: DesignerNode[];
  onAddBinding: (anchorEl: HTMLElement) => void;
  onEditBinding?: (bindingId: number, anchorEl: HTMLElement) => void;
};

export const CssBindingsProvider = ({ children, bindings, onAddBinding, onEditBinding }: Props) => {
  const doesBindingExist = useCallback((name: string) => bindings.some((b) => b.config.name === name), [bindings]);

  const contextValue = useMemo(
    () => ({
      bindings,
      onAddBinding,
      onEditBinding,
      doesBindingExist,
    }),
    [bindings, onAddBinding, onEditBinding, doesBindingExist],
  );

  return <CssBindingsContext.Provider value={contextValue}>{children}</CssBindingsContext.Provider>;
};
